import CryptoJS from 'crypto-js';


const decryptPrivateKey = process.env.JS_AES_PRIVATE_KEY;

const CryptoJSAesJson = {
  stringify: function (cipherParams) {
      var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
      if (cipherParams.iv) j.iv = cipherParams.iv.toString();
      if (cipherParams.salt) j.s = cipherParams.salt.toString();
      return JSON.stringify(j);
  },
  parse: function (jsonStr) {
      var j = JSON.parse(jsonStr);
      var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams;
  }
};


export const decryptJSAesData = (data) => {

  if (!decryptPrivateKey) throw new Error('decrypt private key not configured on build');

  const dataJson = JSON.stringify(data);
  const decryptedData = JSON.parse(CryptoJS.AES.decrypt(dataJson, decryptPrivateKey, {format: CryptoJSAesJson}).toString(CryptoJS.enc.Utf8));;

  return decryptedData;
}